export const LogoMark = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <rect width="48" height="48" rx="13" fill="#1C3B2B" />
    <path d="M16 12v24" stroke="#FBF9F5" strokeWidth="4.2" strokeLinecap="round" />
    <path d="M32.5 15.5 20 24l12.5 8.5" stroke="#FBF9F5" strokeWidth="4.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M35.5 8.5c2.4 3 3.8 5 3.8 7a3.8 3.8 0 1 1-7.6 0c0-2 1.4-4 3.8-7z" fill="#C85A32" />
  </svg>
);

export const LogoFull = ({ dark = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className={`font-display font-bold text-lg tracking-tight leading-none ${dark ? "text-[#FBF9F5]" : "text-[#1C3B2B]"}`}>
      KeDe-Ceaning
      <span className={`block font-jbm text-[10px] font-medium uppercase tracking-[0.28em] mt-1 ${dark ? "text-[#E2EFEA]/70" : "text-[#C85A32]"}`}>
        Shanzu · Mombasa
      </span>
    </span>
  </span>
);
